import Box from '@mui/material/Box';

/** A simple spiral shell mark + lowercase wordmark, until there's a logo (#171). */
export function ShellMark({ size = 26 }: { size?: number }) {
  return (
    <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', gap: 1 }}>
      <svg width={size} height={size} viewBox="0 0 32 32" aria-hidden="true" focusable="false">
        <circle cx="16" cy="16" r="15" fill="#0E7C7B" />
        <path
          d="M16 16 m0 0 a1.5 1.5 0 0 1 1.5 1.5 a3 3 0 0 1 -3 3 a4.5 4.5 0 0 1 -4.5 -4.5 a6 6 0 0 1 6 -6 a7.5 7.5 0 0 1 7.5 7.5 a9 9 0 0 1 -9 9"
          fill="none"
          stroke="#fff"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
      <Box component="span" sx={{ fontWeight: 600, fontSize: 20, letterSpacing: 0.2 }}>
        mollusk
      </Box>
    </Box>
  );
}
